<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c26/guide01.png" alt="비만 치료 주사 병원확인(다음 내용 참조)"  ref="secondImage"/>
        <img class="imgs" src="../../../assets/c26/guide02.png" alt="비만 치료 주사 병원확인(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c26/guide03.png" alt="비만 치료 주사 병원확인(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c26/guide04.png" alt="비만 치료 주사 병원확인(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c26/guide05.png" alt="비만 치료 주사 병원확인(다음 내용 참조)" />
        <img class="imgs last-imgs" src="../../../assets/c26/guide06.png" alt="비만 치료 주사 병원확인(다음 내용 참조)" />
        <div class="sr-only">
            <strong>주 1회 맞는 비만 치료 주사제</strong>
            <h1>수령 가능한 병원을 확인하세요</h1>
            <ul>
                <li>분명히 여기에 재고 있다고 해서 왔는데..(당황한 이모지)</li>
                <li>왜 앱에서 보여주는 것과 가격이 다르죠?(당황한 이모지)</li>
                <li>앱에서는 분명히 이 가격이 아니었는데요(우는 이모지)</li>
                <li>재고 없다고요? 앱에는 재고 있다고 해서 왔는데요?(놀란 이모지)</li>
            </ul>
            <h2>솔닥 인증 병원에서 안심하고 진료보세요</h2>
            <ul>
                <li>허위광고 X</li>
                <li>허위가격 X</li>
                <li>정확한 재고와 단가</li>
            </ul>
            <h3>비만 치료 주사 진료 POINT1</h3>
            <strong>보다 정밀하고 확실한 대면 진료로 진행</strong>
            <p>비만 주사제 처방은 전문 장비를 통한 체성분 측정 등 검사를 실시할 수 있는 [병원 방문 진료]로 진행됩니다</p>
            <ul>
                <li>전문 장비를 통한 체성분 측정</li>
                <li>체성분 결과표 바탕의 체계적인 처방 설계</li>
                <li>꼼수처방 NO, 내 몸 맞춤 솔루션</li>
                <li>주사제 찾아헤멜 필요 없이 원내 바로 픽업</li>
            </ul>
            <h3>비만 치료 주사 진료 POINT2</h3>
            <strong>후속 진료는 비대면진료로 OK</strong>
            <p>추후 추가 진료가 필요하다면 대면/비대면진료 모두 이용 가능해요</p>
            <h3>비만 치료 주사 진료 POINT3</h3>
            <strong>솔닥 이용 수수료는 0원</strong>
            <p>솔닥을 통한 예약으로 발생하는 별도의 추가 수수료는 없습니다</p>
            <dl>
                <dt>결제 내역 상세</dt>
                <dd>솔닥의원 진료비 nn원</dd>
                <dd>처방 내역 nn원</dd>
                <dd>솔닥 수수료 0원</dd>
                <dd>총 결제 금액 nn원</dd>
            </dl>
            <p>예시 화면입니다. 병원병 진료비 등 가격 정보는 진료 예약 시 병원 상세페이지를 확인해 주세요</p>
            <h2>이용 방법</h2>
            <h3>STEP 01 진료 선택</h3>
            <p>1. 병원 방문진료 2. 비만치료 주 1회 선택</p>
            <h3>STEP 02 병원 선택</h3>
            <h3>STEP 03 앱으로 진료 예약</h3>
            <h3>STEP 04 바로 픽업</h3>
            <p>진료 후 바로 수령 가능합니다.</p>
            <h2>지금 바로 재고 보유 기관 목록을 확인하세요</h2>
            <h2>FAQ</h2>
            <dl>
                <dt>Q1. 비대면 진료도 이용 가능한가요?</dt>
                <dd>A1. 비만치료 주사 처방은 대면/비대면 모두 가능하지만, 재고 확인 서비스는 병원 방문 시 이용할 수 있는 서비스입니다. 
                    비대면진료 이용 시, 비만 치료 주사 약국 수령을 위해 재고와 비용을 별도 확인해주셔야 합니다.
                </dd>
            </dl>
            <dl>
                <dt>Q2. 지만치료 주사 가격은 어떻게 되나요?</dt>
                <dd>A2. 진료비 등 각종 비용은 병원병 상세페이지에서 확인 가능합니다.
                </dd>
            </dl>
            <dl>
                <dt>Q3. 처방받은 주사는 어떻게 수령해야 하나요?</dt>
                <dd>A3. 솔닥 예약 후 방문하시면 원내 수령 및 약국 수령 모두 가능합니다.
                    <span>약국 수령의 경우 재고 및 비용 별도 확인 필요</span>
                </dd>
            </dl>
            <dl>
                <dt>Q4. 비용 결제는 어떻게 하나요?</dt>
                <dd>A4. 앱내 원클릭 결제 또는 원내 결제 모두 가능합니다.
                </dd>
            </dl>
            <dl>
                <dt>Q5. 솔닥 수수료는 없나요?</dt>
                <dd>A5. 솔닥을 통해 예약하더라도 발생하는 수수료는 0원입니다.
                </dd>
            </dl>
        </div>
        <a href="soldoc://home/search?departmentId=25?serviceType=CONTACT?type=DEPARTMENT?isEntireRegion=true" target="_blank" title="새 창" :class="['c26-floot-cta first', { scrolled: isScrolled }]">
            <img class="imgs" src="../../../assets/c26/cta-btn1.png" alt="솔닥 모든 제휴 의료기관, 재고 100% 확보 재고 보유처 목록 확인하기" />
        </a>
         <a href="soldoc://home/search?departmentId=24?serviceType=CONTACT?type=DEPARTMENT" target="_blank" title="새 창" :class="['c26-floot-cta', { scrolled: isScrolled }]">
            <img class="imgs" src="../../../assets/c26/cta-btn2.png" alt="솔닥 모든 제휴 의료기관, 재고 100% 확보 재고 보유처 목록 확인하기" />
        </a>
    </div>
</template>

<script>
export default {
    name: "c26",
    data() {
        return {
            isScrolled: false,
        };
    },
    methods: {
        handleScroll() {
            const secondImage = this.$refs.secondImage;
            const rect = secondImage.getBoundingClientRect();
            this.isScrolled = rect.top <= window.innerHeight - 1000;
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>

<style scoped>
    .contain {
        width: 100%;
        max-width: 800px;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        margin: 0 auto;
        overflow: hidden;
    }
    .contain .imgs {
        width: 100%;
    }
    /* .contain .last-imgs {
        margin-bottom: 130px;
    } */
    .contain .sr-only {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        margin: 0 !important;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
    }
    .c26-floot-cta {
        position: fixed;
        bottom: 18px;
        left: calc(50% - 354px);
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.5s ease;
        z-index: 50;
    }
    .c26-floot-cta.scrolled {
        visibility: visible;
        opacity: 1;
    }
    .first {
        bottom: 128px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c26.vue